<template>
  <div>
    <Header></Header>
    <main>
      <div class="section section-alpha">
        <div class="container">
          <h1>Our team</h1>
        </div>
      </div>
      <div class="section section-beta">
        <div class="container">
          <p>
            The team comprises of doctors, scientists and academics from the
            University College London Hospitals (UCLH) and the Institute of
            Women’s health (IfWH) at University College London (UCL)
          </p>
          <p>
            Dr. Neerujah Balachandren (Principal Investigator) is a clinical and
            research fellow in UCLH. She has a keen interest in predicting
            fertility outcomes and fertility preservation.
          </p>
          <p>
            Mr. Dimitrios Mavrelos (Chief Investigator) is a consultant
            Gynaecologist and clinical lead at the Reproductive Medicine Unit in
            UCLH. His research interests include early pregnancy complications
            such as ectopic pregnancy.
          </p>
          <p>
            Miss Ephia Yasmin (Chief Investigator) is a consultant Gynaecologist
            and Person Responsible (PR) at the Reproductive Medicine Unit at
            UCLH. She is the chair for policy and practice at the British
            Fertility Society.
          </p>
          <p>
            <strong>Co-investigators</strong>
          </p>
          <p>
            Miss Melanie Davies is a consultant Gynaecologist at UCLH. Miss
            Davies is an expert in various hormonal conditions in women from
            puberty to menopause. She was the clinical director of the National
            Institute of Health and Care Excellence (NICE) women’s health
            guideline programme.
          </p>
          <p>
            Miss Shirin Khanjani is a consultant gynaecologist at UCLH. Her
            research interests include markers that help predicting successful
            conception.
          </p>
          <p>
            Prof. Judith Stephenson is professor of sexual and reproductive
            health at UCL. She is an expert in the design, conduct,
            interpretation and application of epidemiological (study of diseases
            and conditions in the population) and applied health services
            research.
          </p>
          <p>
            Dr. Geraldine Barrett is a principal research associate in the
            department of reproductive health research at UCL. She is an expert
            in survey techniques and different methods of conducting research.
          </p>
          <p>
            Dr. Jennifer Hall is Principal Clinical Researcher in IfWH at UCL,
            and Honorary Consultant in Public Health, UCLH and Public Health
            England. She has international renown in measurement of pregnancy
            intention and preconception care.
          </p>
          <p>
            Prof. Anna David is the director, professor and Honorary Consultant
            in Obstetrics and Maternal Fetal Medicine at Institute for Women’s
            Health, UCL and UCLH. Her clinical research is on prediction and
            prevention of preterm birth, management of fetal growth restriction
            and fetal surgery.
          </p>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer
  }
};
</script>
